<script>
    import "../previewTabs.css"
    export let setTabsSteps;
    export let tabsSteps;
    export let projectDetails;
    export let tokenDetails;


</script>
<div class="tabs-wrapper flex">
    <ul class="list-none flex">
        {#if projectDetails.story}
            <li><button class="{tabsSteps === 1 ? 'active' : ''}" on:click={() => setTabsSteps(1) }>Project Details</button></li>
        {/if}
        {#if tokenDetails.tokenDetails}
            <li><button class="{tabsSteps === 2 ? 'active' : ''}" on:click={() => setTabsSteps(2) }>Token Details</button></li>
        {/if}
        {#if projectDetails.rewards}
            <li><button class="{tabsSteps === 3 ? 'active' : ''}" on:click={() => setTabsSteps(3) }>Rewards</button></li>
        {/if}
    </ul>
</div>